import fileDownload from 'js-file-download';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useQuestionFlowOverviewRunsExport = (crId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    'QuestionFlowOverviewRunsExport',
    async ({ jobType, filters = {} }) => (
      axiosInstance.post(cleanRoom(orgId).questionFlowRunsExport(crId, jobType), filters)),
    {
      onSuccess: (data) => {
        const contentDisposition = data?.headers?.['content-disposition'];
        let filename = 'run-export.csv';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match?.[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }


        fileDownload(data.data, filename);
        dispatch(showAlert({
          message: 'Successfully downloaded overview CSV',
          type: 'success',
        }));
      },
      onError: (err) => {
        const errorMessage = err?.response?.data?.message || 'Failed to download overview CSV';

        dispatch(showAlert({
          message: errorMessage,
          type: 'error',
        }));
      },
    },
  );
};
